// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.mt-3[data-v-577d5d1d]\n{\n  margin-top: 0em;\n}\n.panel-body[data-v-577d5d1d]\n{\n  padding: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
